import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import styled from '@emotion/styled'
import Navigation from './Navigation'
import Logo from './LogoBlack'
import {isStickySupported} from '../util'

const HeaderContainer = styled.header`
  position: ${props => isStickySupported() ? 'sticky' : props.isFixed ? 'fixed' : 'static'};
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
`

const NavigationContainer = styled.div`
  border-bottom: 2px solid #f2f5f7;
`

const Header = ({isFixed=true, id}) => (
  <>  
    {isFixed && !isStickySupported() && <div style={{paddingTop: '5.35rem'}}/>}
    <HeaderContainer id={id} isFixed={isFixed}>
      <NavigationContainer>
        <Navigation logo={Logo} />
      </NavigationContainer>
    </HeaderContainer>
  </>
)

export default Header
